import { Injectable } from '@angular/core';
import { combineLatest, of, Subject } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import config from '../../data/config.json';
import tokenAbi from '../../data/token-abi.json';
import { BlocknativeService } from '../blocknative.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private contract: any;

  private refresh$ = new Subject();

  constructor(private bncService: BlocknativeService) {}

  refresh() {
    this.refresh$.next();
  }

  tokenAmount$ = combineLatest([
    this.bncService.address$,
    this.bncService.networkId$,
    this.refresh$.pipe(startWith('')),
  ]).pipe(
    switchMap(([address, networkId]) => {
      if (!address || !networkId) return of('-');

      const network = config.networks.find(
        (network) => network.networkId == networkId
      );

      if (!network) return of('-');

      if (!this.contract)
        this.contract = new this.bncService.web3.eth.Contract(
          tokenAbi,
          network.tokenAddress
        );

      return this.contract.methods.balanceOf(address).call() as Promise<string>;
    })
  );

  getAllowance(address: string): Promise<string> {
    return this.contract.methods
      .allowance(this.bncService.address, address)
      .call();
  }

  approve(address: string, amount: string) {
    return this.contract.methods
      .approve(address, amount)
      .send({ from: this.bncService.address, gasPrice: 5_000_000_000 });
  }

  balanceOf(address: string): Promise<string> {
    return this.contract.methods.balanceOf(address).call();
  }
}
